import type { ReactNode } from 'react'
import { Box, Heading, Text } from '@chakra-ui/react';

export interface ProfileCardProps {
  eyebrow: string
  title?: string
  source?: string
  children: ReactNode
}

/**
 * Shared card shell for the District Profile page — matches the slice-4 mockup
 * rhythm: uppercase gray eyebrow, optional heading, body, optional source footer.
 */
export default function ProfileCard({ eyebrow, title, source, children }: ProfileCardProps) {
  return (
    <Box className="profile-card" bg="surface" borderWidth="1px" borderRadius="lg" shadow="sm" p={5} mb={4}>
      <Text
        fontSize="xs"
        fontWeight="bold"
        letterSpacing="0.1em"
        textTransform="uppercase"
        color="gray.500"
      >
        {eyebrow}
      </Text>
      {title && (
        <Heading size="sm" mt={1}>
          {title}
        </Heading>
      )}
      {children}
      {source && (
        <Text fontSize="xs" color="gray.500" borderTopWidth="1px" mt={3} pt={2}>
          {source}
        </Text>
      )}
    </Box>
  )
}
